import Cookies from 'js-cookie';

const VIDEO_IS_PLAYED = 22;

const videoPlayer = () => {
  const video = document.querySelector('.video-player__video');
  const playButton = document.querySelector('.video-player__play-button');
  const seek = document.querySelector('.video-player__seek');
  const progressBar = document.querySelector('.video-player__progress-bar');

  const isVideoSupported = !!document.createElement('video').canPlayType;
  if (isVideoSupported) {
    video.controls = false;
  }

  const togglePlay = () => {
    if (video.paused || video.ended) {
      video.play();
    } else {
      video.pause();
    }
  };

  const updatePlayButton = () => {
    if (video.paused || video.ended) {
      playButton.classList.remove('video-player__play-button--hidden');
    } else {
      playButton.classList.add('video-player__play-button--hidden');
    }
  };

  const initializeVideo = () => {
    const videoDuration = Math.round(video.duration);
    seek.setAttribute('max', videoDuration);
  };

  const updateSeek = () => {
    seek.value = Math.floor(video.currentTime);
    progressBar.style.transform = `scaleX(${
      video.currentTime / video.duration
    })`;

    if (seek.value >= VIDEO_IS_PLAYED) {
      Cookies.set('video', 'true');
    }
  };

  const updateProgress = () => {
    video.currentTime = seek.value;
    progressBar.style.transform = `scaleX(${
      video.currentTime / video.duration
    })`;
  };

  video.addEventListener('click', togglePlay);
  playButton.addEventListener('click', togglePlay);
  video.addEventListener('play', updatePlayButton);
  video.addEventListener('pause', updatePlayButton);
  video.addEventListener('loadedmetadata', initializeVideo);
  video.addEventListener('timeupdate', updateSeek);
  seek.addEventListener('change', updateProgress);
};

export default videoPlayer;
